import React from "react";
import AustriaBloreMain from "./AustriaBloreMain";
import UaeBloreHead from "../../UaeAttestation/UaeBlore/UaeBloreHead";
import "./../../UaeAttestation/UaeBlore/UaeBlore.css";
const AustriaBlore = () => {
  return (
    <div className="uaeBloreContainer">
      <UaeBloreHead head="Austria Apostille in Bangalore" />
      <AustriaBloreMain />
    </div>
  );
};

export default AustriaBlore;
